export default __webpack_public_path__ + "static/media/touchofwinter.cb324b25.png";